import classes from "../../scss/CICD.module.scss";
import Hero from "../../components/Service/Hero";
import HeroTitle from "../../components/Service/HeroTitle";
import HeroText from "../../components/Service/HeroText";
import ContentContainer from "../../components/Service/ContentContainer";
import Wrapper from "../../components/Service/Wrapper";
import Slide from "../../components/Service/Slide";
import SectionText from "../../components/Service/SectionText";
import RequestDemo from "../../components/Button/RequestDemo";
import Section from "../../components/Service/Section";
import SectionTitle from "../../components/Service/SectionTitle";
import SectionList from "../../components/Service/SectionList";
import { data } from "../../data/cicd";
import CollapsibleList from "../../components/Service/CollapsibleList";
import SectionTilesList from "../../components/Service/SectionTilesList";
import Description from "../../components/Service/Description";
import Timeline from "../../components/Service/Timeline";

export default function CICD() {
  return (
    <Wrapper>
      <Hero className={classes.hero}>
        <ContentContainer>
          <div className={classes.hero__body}>
            <Slide className={classes.hero__slide}>
              <HeroTitle
                title={data.hero.title}
                className={classes.hero__title}
              />
              <HeroText text={data.hero.text} className={classes.hero__text} />

              <RequestDemo className={classes.hero__button} />
            </Slide>
            <Slide className={classes.hero__slide}>
              <picture>
                <source
                  srcSet={data.hero.images.full}
                  media="(max-width: 930px) and (min-height: 0)"
                  width="573px"
                  height="718px"
                />
                <source
                  srcSet={data.hero.images.full}
                  media="(min-height: 1024px)"
                  width="573px"
                  height="718px"
                />
                <img
                  src={data.hero.images.regular}
                  alt="Phone"
                  width="573px"
                  height="587px"
                />
              </picture>
            </Slide>
          </div>
        </ContentContainer>
      </Hero>
      <Description
        text={data.description.text}
        title={data.description.title}
      />
      <Section className={classes.toolset__collapsible_wrapper}>
        <CollapsibleList
          title={data.toolset.title}
          list={data.toolset.list}
          className={classes.toolset__collapsible}
        />
      </Section>
      <Section className={classes.principles}>
        <ContentContainer>
          <SectionTitle
            title={data.principles.title}
            className={classes.principles__title}
          />
          <div className={classes.principles__body}>
            <Slide className={classes.principles__slide}>
              <SectionList
                list={data.principles.list}
                className={classes.principles__list}
              />
            </Slide>
            <Slide className={classes.principles__slide}>
              <img
                src={data.principles.image}
                className={classes.principles__image}
                alt="Principles"
                width="700"
                height="525"
              />
            </Slide>
          </div>
        </ContentContainer>
      </Section>
      <Section>
        <ContentContainer>
          <Timeline title={data.stages.title} items={data.stages.flow} />
        </ContentContainer>
      </Section>

      <Section className={classes.toolset}>
        <div className={classes.toolset__body}>
          <div className={classes.toolset__tiles}>
            <ContentContainer>
              <SectionTitle
                title={data.toolset.title}
                className={classes.toolset__title}
              />
              <div className={classes.toolset__tiles_wrapper}>
                <SectionTilesList
                  list={data.toolset.list}
                  className={classes.toolset__tiles_list}
                />
              </div>
            </ContentContainer>
          </div>
        </div>
      </Section>
      <Section className={classes.choose}>
        <ContentContainer>
          <div className={classes.choose__body}>
            <SectionTitle
              title={data.choose.title}
              className={classes.choose__title}
            />
            <Slide className={classes.choose__content}>
              <SectionText
                text={data.choose.text}
                className={classes.choose__text}
              />
              <SectionList
                list={data.choose.list}
                className={classes.choose__list}
              />
            </Slide>
          </div>
        </ContentContainer>
      </Section>
    </Wrapper>
  );
}
